import React from "react";

import Typography from "@mui/material/Typography";
import Tooltip from "@mui/material/Tooltip";
import { CurrencyFormat } from "@/config/normalConfig";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import TableBody from "@mui/material/TableBody";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Collapse from "@mui/material/Collapse";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import Paper from "@mui/material/Paper";

import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import Table from "@mui/material/Table";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import _ from "lodash";
import moment from "moment";
import { useCurrentAction } from "@/hooks/user";

export default function ProfitAndLossDetailTable(props) {
  const { data, selectedDate, defaultCollapseOpen = false } = props;

  const actions = useCurrentAction();

  const [proportionData, setProportionData] = React.useState({});

  const [rows, setRows] = React.useState([]);
  const MARGIN_PERCENT = 0.625;
  function createData(
    type,
    name,
    value,
    style = { underline: false, bold: false, align: "left" },
    details = []
  ) {
    return { type, name, style, value, details };
  }
  const hanldeData = ({
    rrp,
    margin,
    marketingTotalCost,
    marketingExpensesData,
    totalQty,
    scanSales,
    tradeDiscount,
    tradeDiscountDetail,
    promotionRebateTotal,
    promotionRebateDetail,
    revenue,
    sumOfCommission,
    profit,
    proportion,
  }) => {
    console.log("hi");

    let temp = [];

    if (actions?.qty) {
      temp.push(createData("qty", "QTY", totalQty, { format: "qty" }));
    }
    if (actions?.rrp) {
      temp.push(createData("rrp", "RRP Sales", rrp));
    }
    if (actions?.scan) {
      temp.push(createData("scan_sales", "Scan Sales", scanSales));
    }
    if (actions?.margin) {
      temp.push(createData("margin", "Margin", margin));
    }

    if (actions?.rebate) {
      temp.push(
        createData(
          "tradeDiscount",
          "PD(Purchase)",
          tradeDiscount,
          [],
          tradeDiscountDetail
        )
      );
      temp.push(
        createData(
          "rebate",
          "PD (Scan Sales)",
          promotionRebateTotal,
          [],
          promotionRebateDetail
        )
      );
    }
    if (_.every(actions)) {
      temp.push(
        createData("revenue", "Revenue", revenue, {
          underline: true,
          bold: true,
          align: "center",
        })
      );
    }
    if (actions?.commission) {
      temp.push(createData("commission", "Commission", sumOfCommission));
    }
    if (actions?.marketing) {
      temp.push(
        createData(
          "marketing",
          "Marketing Cost",
          marketingTotalCost,
          [],
          marketingExpensesData
        )
      );
    }
    if (_.every(actions)) {
      temp.push(
        createData("profit", "Profit", profit, {
          underline: true,
          bold: true,
          align: "center",
        })
      );
    }
    console.log("temp", temp);
    setProportionData(proportion);
    setRows(temp);
  };
  function Row({ row, proportionData, key, defaultCollapseOpen }) {
    const [open, setOpen] = React.useState(defaultCollapseOpen);

    const renderTitle = (type) => {
      switch (type) {
        case "margin":
          return (
            <Typography variant="inherit" component="div">
              {row.style.bold ? <b>{row.name}</b> : row.name}
            </Typography>
          );
        case "commission":
        case "marketing":
        case "rebate":
        case "tradeDiscount":
          return (
            <Typography variant="inherit" component="div">
              <Tooltip
                title={
                  <>
                    {proportionData[`${row.type}ToScan`] !== null && (
                      <Typography variant="inherit" component="div">
                        Scan :{" "}
                        {new Intl.NumberFormat("en", {
                          minimumFractionDigits: 1,
                        }).format(
                          _.round(proportionData[`${row.type}ToScan`], 1)
                        )}
                        %
                      </Typography>
                    )}
                    {proportionData[`${row.type}ToMargin`] !== null && (
                      <Typography variant="inherit" component="div">
                        Margin :{" "}
                        {new Intl.NumberFormat("en", {
                          minimumFractionDigits: 1,
                        }).format(
                          _.round(proportionData[`${row.type}ToMargin`], 1)
                        )}
                        %
                      </Typography>
                    )}
                  </>
                }
                placement="right"
              >
                {row.style.bold ? <b>{row.name}</b> : row.name}
              </Tooltip>
            </Typography>
          );
        default:
          return (
            <Typography variant="inherit" component="div">
              {row.style.bold ? <b>{row.name}</b> : row.name}
            </Typography>
          );
      }
    };
    const renderValue = (r) => {
      if (r.style.format === "qty") {
        return new Intl.NumberFormat().format(r.value);
      }
      if (row.style.underline) {
        return <u>{CurrencyFormat(r.value, 0)}</u>;
      } else {
        return CurrencyFormat(r.value, 0);
      }
    };
    function renderSubTable(row) {
      switch (row.type) {
        case "tradeDiscount":
          return (
            <Table size="small">
              <TableHead>
                <TableRow key={row.type}>
                  <TableCell>Date</TableCell>
                  <TableCell align="right">Qty</TableCell>
                  <TableCell align="right">Unit Cost</TableCell>
                  <TableCell align="right">Discount</TableCell>
                  <TableCell align="right">Amount</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {row.details.map((detailsRow) => (
                  <TableRow key={detailsRow.date}>
                    <TableCell>{detailsRow.tx_date}</TableCell>
                    <TableCell align="right">
                      {new Intl.NumberFormat().format(detailsRow.qty)}
                    </TableCell>
                    <TableCell align="right">
                      {CurrencyFormat(detailsRow.product_unit_price, 0)}
                    </TableCell>
                    <TableCell align="right">
                      {detailsRow.trade_discount}%
                    </TableCell>
                    <TableCell align="right">
                      {CurrencyFormat(detailsRow.amount, 0)}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          );
        case "rebate":
          return (
            <Table size="small">
              <TableHead>
                <TableRow key={row.type}>
                  <TableCell>Promotion Date</TableCell>
                  <TableCell>Promotion Name</TableCell>
                  <TableCell align="right">Qty(Selected Date)</TableCell>
                  <TableCell align="right">Percent</TableCell>
                  <TableCell align="right">Amount</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {row.details.map((detailsRow) => (
                  <TableRow key={detailsRow.date}>
                    <TableCell>
                      {detailsRow.startDate} ~ {detailsRow.endDate}
                    </TableCell>
                    <TableCell>{detailsRow.discount_name}</TableCell>
                    <TableCell align="right">
                      {new Intl.NumberFormat().format(detailsRow.qty)}
                    </TableCell>
                    <TableCell align="right">{detailsRow.percent}%</TableCell>
                    <TableCell align="right">
                      {CurrencyFormat(detailsRow.rebate_amount, 0)}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          );
        case "marketing":
          return (
            <Table size="small">
              <TableHead>
                <TableRow key={row.type}>
                  <TableCell>Date</TableCell>
                  <TableCell>Category</TableCell>
                  <TableCell>Name</TableCell>
                  <TableCell align="right">Cost (Proportion / Total)</TableCell>
                  <TableCell></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {row.details.map((detailsRow) => (
                  <TableRow
                    key={detailsRow.date}
                    sx={{
                      fontStyle: detailsRow.parent_id ? "italic" : "normal",
                      fontSize: detailsRow.parent_id ? "12px" : "inherit",
                    }}
                  >
                    {detailsRow.parent_id ? (
                      <React.Fragment>
                        <TableCell colSpan={2} align="center">
                          {moment(detailsRow.startDate).format("DD/MM/YY")} ~{" "}
                          {moment(detailsRow.endDate).format("DD/MM/YY")}
                        </TableCell>
                        <TableCell>
                          {detailsRow.parent_id ? "-" : ""} {detailsRow.name}
                        </TableCell>
                      </React.Fragment>
                    ) : (
                      <React.Fragment>
                        <TableCell>
                          {moment(detailsRow.startDate).format("DD/MM/YY")} ~{" "}
                          {moment(detailsRow.endDate).format("DD/MM/YY")}
                        </TableCell>
                        <TableCell>
                          {detailsRow.parent_id ? "" : detailsRow.category}
                        </TableCell>
                        <TableCell
                          sx={{
                            fontStyle: detailsRow.parent_id
                              ? "italic"
                              : "normal",
                            fontSize: detailsRow.parent_id ? "12px" : "inherit",
                          }}
                        >
                          {detailsRow.parent_id ? "-" : ""} {detailsRow.name}
                        </TableCell>
                      </React.Fragment>
                    )}

                    <TableCell align="right">
                      {CurrencyFormat(detailsRow.proportionCost, 0)} /{" "}
                      {CurrencyFormat(detailsRow.totalCost, 0)}
                    </TableCell>
                    <TableCell>
                      <IconButton
                        onClick={() => {
                          window.open(
                            `/expenses/view/${detailsRow.id}`,
                            "_blank"
                          );
                        }}
                      >
                        <OpenInNewIcon></OpenInNewIcon>
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          );
        default:
          break;
      }
    }

    return (
      <React.Fragment>
        <TableRow key={key} sx={{ "& > *": { borderBottom: "unset" } }}>
          <TableCell width={10}>
            {row.details.length > 0 && (
              <IconButton
                aria-label="expand row"
                size="small"
                onClick={() => setOpen(!open)}
              >
                {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
              </IconButton>
            )}
          </TableCell>
          <TableCell align={row.style.align} component="th" scope="row">
            {renderTitle(row.type)}
          </TableCell>
          <TableCell align="right">{renderValue(row)}</TableCell>
          {(row.type === "commission" ||
            row.type === "marketing" ||
            row.type === "rebate" ||
            row.type === "tradeDiscount") && (
            <React.Fragment>
              {proportionData[`${row.type}ToScan`] !== null && (
                <TableCell width={10} align="right">
                  {new Intl.NumberFormat("en", {
                    minimumFractionDigits: 1,
                  }).format(_.round(proportionData[`${row.type}ToScan`], 1))}
                  %
                </TableCell>
              )}
              {proportionData[`${row.type}ToMargin`] !== null && (
                <TableCell width={10} align="right">
                  {new Intl.NumberFormat("en", {
                    minimumFractionDigits: 1,
                  }).format(_.round(proportionData[`${row.type}ToMargin`], 1))}
                  %
                </TableCell>
              )}
            </React.Fragment>
          )}
        </TableRow>
        {row.details.length > 0 && (
          <TableRow>
            <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
              <Collapse in={open} timeout="auto" unmountOnExit>
                <Box sx={{ margin: 1 }}>{renderSubTable(row)}</Box>
              </Collapse>
            </TableCell>
          </TableRow>
        )}
      </React.Fragment>
    );
  }
  React.useEffect(() => {
    if (!_.isEmpty(data)) hanldeData(data);
  }, [data]);
  return (
    <TableContainer sx={{ mt: 1 }} component={Paper}>
      <Table
        sx={{
          [`& .${tableCellClasses.root}`]: {
            borderBottom: "none",
          },
        }}
        aria-label="simple table"
      >
        <TableHead>
          <TableRow>
            <TableCell colSpan={5} align="center">
              {/* {data.product_name} */}
            </TableCell>
          </TableRow>
          <TableRow>
            {moment(selectedDate.startDate).isValid() &&
              moment(selectedDate.endDate).isValid() && (
                <TableCell colSpan={5} align="center">
                  {selectedDate.startDate} - {selectedDate.endDate}
                </TableCell>
              )}
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((r) => (
            <Row
              key={r.name}
              row={r}
              proportionData={proportionData}
              defaultCollapseOpen={defaultCollapseOpen}
            />
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
